<template>
  <div class="">
    <v-layout row wrap>
      <v-flex lg5 md5 sm12 xs12>
        <v-container>
          <v-card flat>
            <v-card-title><h4 class="earth-color">IMMERSIVE CONSERVATION EXPERIENCE PROGRAM CONTACTS</h4></v-card-title>
            <v-container>
              <v-form  @submit.prevent="postUserType()">
                <v-text-field
                  label="Full Name"
                  v-model="contact.full_name"
                  :rules="requiredRules"
                  required
                ></v-text-field>
                <v-text-field
                  label="Email"
                  v-model="contact.email"
                  :rules="requiredRules"
                  required
                  type="email"
                ></v-text-field>
                <v-btn :depressed="true" color="primary" block type="submit" v-if="update === false">Add</v-btn>
                <v-btn :depressed="true" color="warning" block type="submit" v-if="update === true">Update</v-btn>
              </v-form>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex lg7 md7 sm12 xs12>
        <v-container>
          <v-card flat>
            <v-card-title><h4 class="earth-color">IMMERSIVE CONSERVATION EXPERIENCE PROGRAM NOTIFICATION CONTACTS</h4></v-card-title>
            <v-container>
              <table cellpadding="1" cellspacing="1" class="table">
                <thead>
                <tr>
                  <td>#</td>
                  <td>Full Name</td>
                  <td>Email</td>
                  <td>Action</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(type, index) in $allVolunteerContacts" :key="index">
                  <td>{{index + 1}}</td>
                  <td>{{type.full_name}}</td>
                  <td>{{type.email}}</td>
                  <td>
                    <v-btn :depressed="true" color="warning" v-if="update === true" small @click="cancelAmendment()">Cancel Amendment</v-btn>
                    <v-btn :depressed="true" color="warning" v-if="update === false" small @click="updateType(type)">Amend</v-btn>
                    <v-btn :depressed="true" color="error" v-if="update === false" small @click="deleteUserType(type.public_id)">Disable</v-btn>
                  </td>
                </tr>
                </tbody>
              </table>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'VolunteerProgramSettings',
  data () {
    return {
      update: false,
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      contact: {
        full_name: '',
        email: '',
        program_id: this.$route.params.program_id
      }
    }
  },
  created () {
    this.$store.dispatch('get_all_volunteer_contacts', this.$route.params.program_id)
  },
  methods: {
    cancelAmendment: function () {
      this.update = false
      this.contact.full_name = ''
      this.contact.email = ''
    },
    updateType: function (type) {
      this.update = true
      this.contact = type
    },
    deleteUserType: function (publicId) {
      var data = {
        public_id: publicId,
        program_id: this.$route.params.program_id
      }
      this.$store.dispatch('delete_volunteercontact', data)
    },
    postUserType: function () {
      this.$store.dispatch('loading_true')
      // var instance = this
      if (this.update === false) {
        this.$store.dispatch('post_volunteercontact', this.contact)
      } else {
        this.$store.dispatch('update_volunteercontact', this.contact)
      }
    }
  }
}
</script>

<style>

</style>
